import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import t, { mixin } from "theme"
import InputBox from "components/UI/InputBox"

export const Root = styled.div`
    position: relative;
    display: grid;
    grid-gap: 1em;
`
export const SearchIcon = () => (
    <i
        className="icon-search"
        css={css`
            font-size: ${t.font.size[8]};
            ${mixin.phonestyle} {
                font-size: ${t.font.size[4]};
            }

            margin-left: ${t.space[5]};
            margin-right: ${t.space[1]};
        `}
    />
)

export const TextBox = styled(InputBox)`
    display: none;
`

export const Form = styled.form`
    display: flex;
    align-items: center;
`
export const HitsWrapper = styled.div`
    display: ${props => (props.show ? `grid` : `none`)};
    max-height: 80vh;
    overflow: scroll;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    position: absolute;
    right: 0;
    top: calc(100% + 0.5em);
    width: 80vw;
    max-width: 30em;
    box-shadow: 0 0 5px 0;
    padding: 0.7em 1em 0.4em;
    background: white;
    border-radius: 4px;
    > * + * {
        padding-top: 1em !important;
        border-top: 2px solid ${t.color.regtext};
    }
    li + li {
        margin-top: 0.7em;
        padding-top: 0.7em;
        border-top: 1px solid ${t.color.subtlegrey};
    }
    * {
        margin-top: 0;
        padding: 0;
    }
    ul {
        list-style: none;
    }
    mark {
        color: ${t.color.light};
        background: ${t.color.primary};
    }
    header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.3em;
        h3 {
            color: ${t.color.primary};
        }
    }
    h3 {
        margin: 0 0 0.5em;
    }
    h4 {
        margin-bottom: 0.3em;
    }
`
